import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

import { Modal }  from 'react-bootstrap';
import { FaCircleNotch } from "react-icons/fa6";

import PrivateRoute from "./components/PrivateRoute";

import ErrorBoundary from "./ErrorBoundary";

import GuestLogin from "./pages/GuestLogin";
import Demo1Login from "./pages/Demo1Login";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import SessionEnded from "./pages/web/SessionEnded";

import GuestHome from "./pages/home/GuestHome";
import Demo1Home from "./pages/home/Demo1Home";
import Home from "./pages/home/Home";
import HeadToHead from "./pages/games/headtohead/HeadToHead";
import Placement from "./pages/games/placement/Placement";
import Bracket from "./pages/games/bracket/Bracket";
import PickTheProps from "./pages/games/picktheprops/PickTheProps";
import Survivor from "./pages/games/survivor/Survivor";
import PrePick from "./pages/games/survivor/PrePick";
import Leaderboard from "./pages/games/survivor/Leaderboard";

import LaunchEntry from "./pages/launch/LaunchEntry";
import RemoteCompleteScreen from "./pages/launch/RemoteCompleteScreen";
import WebLaunchRedirect from "./pages/launch/WebLaunchRedirect";
import { readRemoteSession, applyKeyboardMode } from "./context/RemoteLaunchContext";

class App extends Component {
    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);

        this.state = {
            /*currentAuth: undefined,*/
            modal: {show: false, text: ""}
        };
    }

    componentDidMount(){
        // Re-apply the on-screen keyboard mode on hard reload while a remote
        // launch session is still live in sessionStorage.
        var remote = readRemoteSession();
        if (remote && remote.displayOptions) {
            applyKeyboardMode(remote.displayOptions.keyboard);
        }
    }

    showModal(new_text){
        this.setState({
            modal:{show: true, text: new_text}
        }, () => {
            let dom = document.querySelector(".master-modal .body");
            if(dom && this.state.modal.text != ""){
                dom.innerHTML = "";
                let text = this.state.modal.text;
                text = text.split(/(?:\r\n|\r|\n)/g);
                for(var i=0; i<text.length; i++){
                    if(text[i]) {
                        let p = document.createElement("p");
                        p.textContent = text[i];
                        p.classList.add("mb-0")
                        dom.appendChild(p);
                    }
                }
            }
        })
    }

    hideModal(){
        this.setState({
            modal: {show: false, text: ""}
        })
    }

    render() {
        return (
            <div>
                <ErrorBoundary>
                    <Modal className="master-modal" show={this.state.modal.show} animation={true} centered>
                        <Modal.Body className='text-center' style={{"fontSize": "1.2em", "color": "white"}}>
                            <FaCircleNotch className="icon-spin mb-1" style={{ fontSize: "2em" }}/>
                            <div className="body"></div>
                        </Modal.Body>
                    </Modal>
                    <Routes>
                        <Route path="/" element={<PrivateRoute/>}>
                            <Route path="/" element={<Home showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/home" element={<Home showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/head_to_head" element={<HeadToHead showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/placement" element={<Placement showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/bracket" element={<Bracket showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="pick_the_props" element={<PickTheProps showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/survivor" element={<Survivor showModal={this.showModal} hideModal={this.hideModal} />} />
                            {/* SUR-401 — the entry manager. Sits above the pick
                                screen: it lists every active promotion, so it
                                replaces the lobby rather than belonging to one
                                promo. */}
                            <Route path="/survivor/prepick" element={<PrePick showModal={this.showModal} hideModal={this.hideModal} />} />
                            {/* SUR-460..SUR-466 — the pool boards, in the entry
                                manager's own format. */}
                            <Route path="/survivor/leaderboard" element={<Leaderboard showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/guest/home" element={<GuestHome showModal={this.showModal} hideModal={this.hideModal} />} />
                            <Route path="/demo1/home" element={<Demo1Home showModal={this.showModal} hideModal={this.hideModal} />} />
                        </Route>
                        {/* SUR-467 — the same board addressed by the venue's
                            public slug, for a URL somebody types or a venue
                            prints. Outside PrivateRoute, and that placement is
                            the whole requirement: it was written inside it, so
                            a cold browser was bounced to /login and the one
                            thing this route exists for did not work. The board
                            itself was already ready — it takes its venue from
                            the slug and guards every read of the session — and
                            the API it calls is deliberately unauthenticated. */}
                        <Route path="/survivor/leaderboard/:slug" element={<Leaderboard showModal={this.showModal} hideModal={this.hideModal} />} />
                        <Route path="/guest/login" element={<GuestLogin showModal={this.showModal} hideModal={this.hideModal} />} />
                        <Route path="/demo1/login" element={<Demo1Login showModal={this.showModal} hideModal={this.hideModal} />} />
                        <Route path="/login" element={<Login showModal={this.showModal} hideModal={this.hideModal} />} />
                        <Route path="/logout" element={<Logout />} />
                        {/* WEB-410 -- outside PrivateRoute on purpose. It is
                            where a player goes when they have no session, so
                            requiring one to see it would loop. */}
                        <Route path="/session-ended" element={<SessionEnded />} />
                        {/* Only reached when the edge has not been told that
                            /go/ belongs to Django. Bounces to the origin that
                            serves it — see WebLaunchRedirect. */}
                        <Route path="/go/:slug" element={<WebLaunchRedirect />} />
                        <Route path="/launch-entry" element={<LaunchEntry showModal={this.showModal} hideModal={this.hideModal} />} />
                        <Route path="/launch-complete" element={<RemoteCompleteScreen />} />
                    </Routes>
                </ErrorBoundary>
            </div>
        );
    }
}

export default App;